import { render, staticRenderFns } from "./InfoArtworkModal.vue?vue&type=template&id=040af2b4&scoped=true&"
import script from "./InfoArtworkModal.vue?vue&type=script&lang=js&"
export * from "./InfoArtworkModal.vue?vue&type=script&lang=js&"
import style0 from "./InfoArtworkModal.vue?vue&type=style&index=0&id=040af2b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040af2b4",
  null
  
)

export default component.exports